export function dontDisplayParameter(parameters, key) {
  if (!parameters || !parameters.length > 0) return false;
  return parameters.some(param => param.key === key && param.value === 'Não');
}
export function displayParameter(parameters, key) {
  if (!parameters || !parameters.length > 0) return true;
  return parameters.some(param => param.key === key && (param.value === 'Sim' || param.value === 'true'));
}
